import axios from 'axios';
import { call, put, takeEvery, delay } from 'redux-saga/effects';
import { STATION_RECORD_REQUEST, stationRecordSuccess, stationRecordFailure} from '../actions/stationQueryAction';
import { API_PATH }  from '../config';
import { authHeader } from '../helper/authHeader';

const STATION_LIST_API = `${API_PATH}/station`;

const stationRecordApi = (stationId) => {
   return axios.get(`${STATION_LIST_API}/${stationId}`, 
      {
         headers: {...authHeader()},
         timeout: 10000
      }).then( (response) => response.data);
}

function* stationRecord(action) {
   yield delay(3000);
   let fetch = undefined;
   let stationId = action.stationId;
   try {
      fetch = yield call(stationRecordApi, stationId);
      if (fetch) {
         if (fetch.success) {
            yield put(stationRecordSuccess(stationId, fetch.result));
         } else {
            yield put(stationRecordFailure(stationId, '系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(stationRecordFailure(stationId, '資料錯誤 !'));
      }

   } catch (error) {
      yield put(stationRecordFailure(stationId, `資料錯誤, ${error.message}`));
   }
}

export default function* watchStationRecordAction() {
   yield takeEvery(STATION_RECORD_REQUEST, stationRecord);
}